import { cn } from "@/components/podkit/lib/cn";
import { Counter } from "@/components/flexkit/badge/Counter";
import { Tooltip } from "@/components/Tooltip";
import type { FC, ReactNode } from "react";

export type ConversationTabButtonProps = {
    id: string;
    label: string;
    icon: ReactNode;
    isActive: boolean;
    onClick: () => void;
    panelId: string;
    badge?: number;
    hideLabel?: boolean;
    "data-tracking-id": string;
};

export const ConversationTabButton: FC<ConversationTabButtonProps> = ({
    id,
    label,
    icon,
    isActive,
    onClick,
    panelId,
    badge,
    hideLabel = false,
    "data-tracking-id": trackingId,
}) => {
    const button = (
        <button
            id={id}
            role="tab"
            aria-selected={isActive}
            aria-controls={panelId}
            aria-label={hideLabel ? label : undefined}
            onClick={onClick}
            className={cn(
                "flex items-center gap-1.5 rounded-md px-3 py-1 text-base transition-colors",
                isActive
                    ? "bg-surface-button-tab-primary text-content-primary shadow-sm"
                    : "text-content-secondary hover:text-content-primary",
            )}
            data-tracking-id={trackingId}
        >
            {icon}
            {!hideLabel && label}
            {badge !== undefined && badge > 0 && <Counter counter={String(badge)} className="text-xs" />}
        </button>
    );

    if (hideLabel) {
        return <Tooltip content={label}>{button}</Tooltip>;
    }

    return button;
};
